import React, { Component } from "react";
import moment from "moment";
import { NavLink } from "react-router-dom";

const PurchaseOrder = ({ purchaseOrder, status, handleDelete }) => {
  const date = purchaseOrder ? moment(purchaseOrder.date).format("L") : "";
  const deliveryDate =
    purchaseOrder && purchaseOrder.delivery_date
      ? moment(purchaseOrder.delivery_date).format("L")
      : "-";
  const hasInvoice = purchaseOrder && purchaseOrder.invoice;
  return (
    <tr>
      <td className="hidden-xs-down">
        {purchaseOrder ? purchaseOrder.id : ""}
      </td>
      <td>{purchaseOrder ? purchaseOrder.vendor.name : ""}</td>
      <td className="hidden-md-down">
        {purchaseOrder && purchaseOrder.invoice ? purchaseOrder.invoice : "-"}
      </td>
      <td className="hidden-md-down">{date}</td>
      <td>{deliveryDate}</td>
      <td className="hidden-xs-down">
        {purchaseOrder ? purchaseOrder.num_items : ""}
      </td>
      <td className="hidden-xs-down">
        {purchaseOrder ? purchaseOrder.created_by.username : ""}
      </td>
      <td className="hidden-xs-down">
        <span className={`badge badge-pill custom-badge ${status.badgeClass}`}>
          {status.name}
        </span>
      </td>
      <td>
        <span className="d-flex">
          {purchaseOrder.status === 0 && (
            <NavLink
              to={`/purchase_orders/${purchaseOrder.id}`}
              className={({ isActive }) =>
                `ml-05 btn-sm btn-primary ${isActive ? "active" : ""}`
              }
            >
              <i className="fa fa-edit "></i>
            </NavLink>
          )}
          {purchaseOrder.status === 1 &&
            (hasInvoice ? (
              <NavLink
                to={`/purchase_orders/${purchaseOrder.id}/invoice`}
                className={({ isActive }) =>
                  `ml-05 btn-sm btn-primary ${isActive ? "active" : ""}`
                }
              >
                <i className="fa fa-eye "></i>
              </NavLink>
            ) : (
              <NavLink
                to={`/purchase_orders/${purchaseOrder.id}`}
                className={({ isActive }) =>
                  `ml-05 btn-sm btn-primary ${isActive ? "active" : ""}`
                }
              >
                <i className="fa fa-eye "></i>
              </NavLink>
            ))}
          {purchaseOrder.status === 2 && (
            <NavLink
              to={`/purchase_orders/${purchaseOrder.id}`}
              className={({ isActive }) =>
                `ml-05 btn-sm btn-primary ${isActive ? "active" : ""}`
              }
            >
              <i className="fa fa-eye "></i>
            </NavLink>
          )}
          {(purchaseOrder.status === 0 ||
            (purchaseOrder.status === 1 && !hasInvoice)) && (
            <span
              className="ml-05 btn btn-sm btn-danger mr-0"
              onClick={handleDelete}
            >
              <i className="fa fa-trash"></i>
            </span>
          )}
        </span>
      </td>
    </tr>
  );
};

export default class PurchaseOrderList extends Component {
  render() {
    const { purchaseOrders, statusOptions, handleDelete } = this.props;
    return (
      <tbody>
        {purchaseOrders.map((purchaseOrder) => {
          return (
            <PurchaseOrder
              purchaseOrder={purchaseOrder}
              status={statusOptions[purchaseOrder.status]}
              key={purchaseOrder.id}
              handleDelete={() => handleDelete(purchaseOrder.id)}
            />
          );
        })}
      </tbody>
    );
  }
}
